import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [8, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Shape/1UnderstandAnglesAsTurns" */ './1UnderstandAnglesAsTurns'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year4/Summer/Shape/2IdentifyAngles" */ './2IdentifyAngles')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Shape/3CompareAndOrderAngles" */ './3CompareAndOrderAngles'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () => import(/* webpackChunkName: "Year4/Summer/Shape/4Triangles" */ './4Triangles')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(/* webpackChunkName: "Year4/Summer/Shape/5Quadrilaterals" */ './5Quadrilaterals')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () => import(/* webpackChunkName: "Year4/Summer/Shape/6Polygons" */ './6Polygons')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year4/Summer/Shape/7LinesOfSymmetry" */ './7LinesOfSymmetry')
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Shape/8CompleteASymmetricFigure" */ './8CompleteASymmetricFigure'
        )
    })
  ]
});
export default Block;
